<template>

        <el-dialog title="导入excel" style="margin-top:100px;" width="600px" :visible.sync="dialogVisible" @close="closeForm" append-to-body>
            <div style="color:#f36765;font-size:16px;font-weight:bold;margin-bottom:30px;">导入表格确定执行后，会删除所有列表中，除表格存在的ID以外的全部商品(除了铺货中)请谨慎使用!</div>
            <el-upload v-if="!process" class="upload-demo" action :auto-upload="false" :show-file-list="false" :on-change="choose_file">
                <el-button size="mini" icon="el-icon-upload" type="primary">请选择导入excel</el-button> 
                <span style="color:#ff0000">{{file.name}}</span>
            </el-upload>
            <el-progress v-else :percentage="percentage"></el-progress>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading || parsing" :disabled="parsing" type="primary" @click="submit">
                    <span v-if="!loading && !parsing">确 定</span>
                    <span v-else-if="parsing">解 析 中...</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
	
</template>

<script>
import { mapActions } from "vuex";
import XLSX from "../../assets/js/utils/xlsx.core.min.js";
	export default {
		name: "importform",
		props: {
        show: {
            type: Boolean,
            default: false
        },
        shop_id: {
            type: Number,
            default: 0
        },
        size: {
            type: String,
            default: 'mini'
        }
    },
    data() {
        return {
            dialogVisible: false,
            file: "",
            process: false,
            loading: false,
            parsing: false,
            excel_import_data: [],
            percentage: 0,
            page: 1,
            limit: 100
        }
    },
    watch: {
        show(val) {
            this.dialogVisible = val;
        },
        dialogVisible(val) {
            this.$emit('update:show', val);
        }
    },
    methods: {
        ...mapActions({
			leadintoApi:"ucenter/leadintoApi",
		}),
        choose_file(file) {
            this.file = file;
            this.parsing = true;
            this.importExcel(file);
        },
        importExcel(file) {
            var excelData = [];
            const fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, { type: "binary" });
                    Object.keys(workbook.Sheets).forEach((sheet) => {
                        excelData.push(
                            ...XLSX.utils.sheet_to_json(workbook.Sheets[sheet], { defval: "" })
                        );
                    });
                    
                    this.excel_import_data = excelData;
                    this.$message.success("文件解析成功！");
                    this.parsing = false;
                } catch (e) {
                    this.$message.error("文件类型不正确");
                    this.parsing = false;
                }
            };
            fileReader.readAsBinaryString(file.raw);
        },
        submit() {
            this.process = true;
            this.loading = true;

            // 计算总页数
            const total_page = Math.ceil(this.excel_import_data.length / this.limit);
            const data = this.getData();

            // 更新进度条
            this.percentage = Math.ceil((this.page / total_page) * 100);

            // 构造请求参数
            const payload = {
                data: data,
                shop_id: this.shop_id,
                status: this.page==total_page?1:0,
            };
            this.leadintoApi(
                { data:payload,success:(res)=>{
				if(res.code===200){
                    if (this.page < total_page) {
                        this.page += 1;
                        this.submit();
                    } else {
                        console.log('结束了')
                        this.$message.success(res.msg || '导入成功');
                        this.$emit('refesh_list');
                        this.closeForm();
                    }
				} else {
                    this.$message.error(res.msg || '导入失败');
                    
				}
			
			}}   
            )
            // // 提交数据
            // axios.post(base_url + '/Gys.SupplierOrder/shujudaoru', payload).then(res => {
            //     if (res.data.code == 200) {
            //         if (this.page < total_page) {
            //             this.page += 1;
            //             this.submit();
            //         } else {
            //             this.$message.success(res.data.msg || '导入成功');
            //             this.$emit('refesh_list');
            //             this.closeForm();
            //         }
            //     } else {
            //         this.$message.error(res.data.msg || '导入失败');
            //     }
            // }).catch(() => {
            //     this.loading = false;
            //     this.$message.error('导入失败');
            // });
        },
        getData() {
            let perdata = [];
            for (let i = (this.page - 1) * this.limit; i < this.page * this.limit; i++) {
                if (this.excel_import_data[i]) {
                    perdata.push(this.excel_import_data[i]);
                }
            }
            return perdata;
        },
        closeForm() {
            this.$emit('update:show', false);
            this.resetForm();
        },
        resetForm() {
            this.file = '';
            this.process = false;
            this.percentage = 0;
            this.loading = false;
            this.parsing = false;
            this.page = 1;
            this.limit = 100;
            this.excel_import_data = [];
        }
    }
	}
</script>

<style scoped>

</style>